
import { Position } from './position.model';

export class GeoCircle {

    public center: Position;
    public radius: number;

    constructor(obj?: Partial<GeoCircle>) {
        Object.assign(this, obj);
    }

}
